import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText, Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusic, currentBackgorundMusicVolume, isMusicBtnOnGlobal, languageGlobal, setBackgorundMusic } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { isFireFox } from "../utils";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// import { setBackgorundMusic, currentBackgorundMusicVolume } from "../config/GlobalVariableConfig";

export class Banner extends Container {

    private bgContainer = new Container();
    private texContainer = new Container(); //-- which needed to scale without any limit

    private backgroundImg: Sprite;

    private bannerText1: Text = new Text({});
    private bannerText2: Text = new Text({});
    private bannerText3: Text = new Text({});
    private bannerText4: Text = new Text({});
    // private bannerText5: Text = new Text({});
    private continueText: Text = new Text({});

    // -- Added base sprite for continue text
    private continueBase: Sprite;

    // private backgroundSpine: Spine | null = null;

    private winText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: "symbol_multiplier",
            trim: true,
            fontSize: 125,
            letterSpacing: 5,
        }
    });

    private baseAnim: Spine | null = null;
    // private transitionAnim: Spine | null = null;
    //private rightCharacter: Spine | null = null;
    // private rightCharacter: Sprite | null = null;

    private tweenGroup: Group = new Group();

    private screenWidth: number;
    private screenHeight: number;


    constructor(screenWidth: number, screenHeight: number) {
        super();



        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.setupBGImage();

        this.setupBackground();
        this.setupBannerText();

        this.setupBaseAnim();

        // this.setupTransitionAnim();

        this.visible = false;

        // this.bgContainer.eventMode = "static"
        this.resize(screenWidth, screenHeight);

    }

    private setupBGImage(): void {
        // this.backgroundImg.label = "backgroundImg";

        this.backgroundImg = Sprite.from("freegame_intro_bg");
        this.backgroundImg.alpha = 0;
        this.backgroundImg.label = "backgroundImg";
        this.addChild(this.backgroundImg);
    }
    private setupBackground(): void {


        // this.backgroundSpine = Spine.from({
        //     skeleton: "bannerSkel",
        //     atlas: "bannerAtlas",
        // });


        // this.backgroundSpine.position.set(1920 / 2, 1080 / 2);

        // spineSymbol.scale=0.1;

        // this.backgroundSpine.state.setAnimation(0, "loop", true);

        // this.bgContainer.addChild(this.backgroundSpine);
        this.addChild(this.bgContainer);


        this.addChild(this.texContainer);

    }

    private setupBaseAnim(): void {
        this.baseAnim = Spine.from({
            skeleton: "bannerBaseSkel",
            atlas: "bannerBaseAtlas"
        })
        this.baseAnim.state.apply(this.baseAnim.skeleton);
        this.baseAnim.visible = false;
        // this.leftCharacter.position.set(1900, 400);
        this.bgContainer.addChild(this.baseAnim);
    }

    // private setupTransitionAnim() {
    //     this.transitionAnim = Spine.from({
    //         skeleton: "transitionSkel",
    //         atlas: "transitionAtlas"
    //     })
    //     this.transitionAnim.visible = false;
    //     this.transitionAnim.position.set(1920 / 2, 1080 / 2);
    //     this.bgContainer.addChild(this.transitionAnim);
    // }


    private setupBannerText(): void {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");



        const fill = new FillGradient(0, 0, 0, fontSizeHeading * 1.4);
        const colors = ["#e2fdff", "#adf6fd", "#63bfff"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.bannerText1.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: isFireFox() ? "#ffffff" : { fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#06044a",
                width: 6,
                join: "round"
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 8,
                    color: "#0090ff",
                    distance: 0,
                    alpha: 1
                },
            letterSpacing: 2,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });



        const {
            fontFamily: fontFamilyDesc1,
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            lineHeight: lineHeightDesc1
        } = getFontConfig(languageGlobal, "introDesc1")

        this.bannerText2.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: isFireFox() ? "#ffffff" : { fill },
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            // stroke: {
            //     color: "#000000",
            //     width: 3,
            // },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#000000",
                    distance: 0,
                    alpha: 1
                },
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            breakWords: true,
            wordWrap: true,
            wordWrapWidth: 850,
            lineHeight: lineHeightDesc1,
        });


        const {
            fontFamily: fontFamilyDesc2,
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            lineHeight: lineHeightDesc2
        } = getFontConfig(languageGlobal, "introDesc2");

        const desc2TextStyle = new TextStyle({
            fontFamily: fontFamilyDesc2,
            fill: "#ffffff",
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            stroke: {
                color: "#935a10",
                width: 2,
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#011932",
                    distance: 0,
                    alpha: 1
                },
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: 1,
            wordWrapWidth: 850,
            lineHeight: lineHeightDesc2,
            breakWords: true,
        });

        this.bannerText3.style = desc2TextStyle;
        this.bannerText4.style = desc2TextStyle;
        // this.bannerText5.style = desc2TextStyle;


        const {
            fontFamily: fontFamilyContinue,
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
        } = getFontConfig(languageGlobal, "introContinue");

        const continueTextStyle = new TextStyle({
            fontFamily: fontFamilyContinue,
            fill: isFireFox() ? "#ffffff" : { fill },//"#ffffff",
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
            stroke: {
                color: "#2409b7",
                width: 6,
                join: "round"
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 6,
                    color: "#000000",
                    distance: 0,
                    alpha: 1
                },
        });

        this.continueText.text = translationManager.game('intro_continue_uc')
        this.continueText.style = continueTextStyle

        // -- SETUP CONTINUE BASE SPRITE --
        this.continueBase = Sprite.from("continueBase");
        this.continueBase.anchor.set(0.5);


        this.bannerText1.anchor.set(0.5);
        this.bannerText2.anchor.set(0.5);
        this.bannerText3.anchor.set(0.5);
        this.bannerText4.anchor.set(0.5);
        // this.bannerText5.anchor.set(0.5);
        this.continueText.anchor.set(0.5);
        this.winText.anchor.set(0.5);

        // const spacing = 20;
        this.texContainer.addChild(this.bannerText1);
        this.texContainer.addChild(this.bannerText2);
        this.texContainer.addChild(this.bannerText3);
        this.texContainer.addChild(this.bannerText4);
        // this.texContainer.addChild(this.bannerText5);

        // Add base before text so it is behind
        this.texContainer.addChild(this.continueBase);
        this.texContainer.addChild(this.continueText);

        this.texContainer.addChild(this.winText);
    }

    private isIntroBanner: boolean = true;

    public async appearFreeGameIntroBanner(freeGameNumber: number) {

        return new Promise<void>(async (resolve) => {

            this.isIntroBanner = true;
            // this.visible = true;
            this.bannerText1.visible = true;
            this.bannerText2.visible = true;
            this.bannerText3.visible = true;
            this.bannerText4.visible = true;
            // this.bannerText5.visible = true;

            this.winText.visible = false;

            this.bannerText1.scale = 1;
            this.bannerText1.text = translationManager.game('banner_intro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 900 / this.bannerText1.width);
            this.bannerText1.y = -430;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_intro_desc_1', null, { 'freegamenumber': freeGameNumber });//`You won ${freeGameNumber} Free Spins!`
            this.bannerText2.y = -270;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);

            this.bannerText3.text = translationManager.game('banner_intro_desc_2');//'During the bonus game, the multiplier accumulates with each win that involves a wild symbol with a multiplier.';
            this.bannerText3.y = -120;
            // this.bannerText3.scale = Math.min(1, (this.bannerBackground.width - 150) / this.bannerText3.width);

            this.bannerText4.text = translationManager.game('banner_intro_desc_3');//'The multiplier persists throughout the entire duration of the bonus game.';
            this.bannerText4.y = 115;

            // this.bannerText5.text = translationManager.game('banner_intro_desc_4');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText5.y = 250;

            this.continueText.y = 340;

            this.resize(this.screenWidth, this.screenHeight); // to set the position according to screen size

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            this.visible = true;

            // sound.play('free_Game_Banner', { volume: 0.5 });

            // this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
            //     complete: async () => {
            //         this.backgroundSpine.state.setAnimation(0, "loop", true);

            //         await this.appearText(true);
            //         resolve();

            //         this.backgroundSpine.state.clearListeners();
            //     }
            // };


            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 200)
                    .onStart(() => {
                        sound.play('free_Game_Banner', { volume: 0.5 });
                    })
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })



            const promises: Promise<void>[] = [];

            const playInAnimation = (baseAnimSpine: Spine) => {
                return new Promise<void>((resolve) => {
                    baseAnimSpine.visible = true;
                    baseAnimSpine.state.setAnimation(0, "in", false).listener = {
                        complete: () => {
                            baseAnimSpine.state.setAnimation(0, "loop", true);
                            baseAnimSpine.state.clearListeners();
                            resolve();
                        },
                        start: () => {
                            baseAnimSpine.visible = true;
                        },
                    };
                });
            };

            promises.push(playInAnimation(this.baseAnim));
            //promises.push(playInAnimation(this.rightCharacter));

            Promise.all(promises).then(async () => {
                await this.appearText(true);
                resolve();
            });

        })


    }

    private appearText(toFreeGame: boolean) {

        return new Promise<void>((resolve) => {

            let textScale;
            if (this.screenWidth > this.screenHeight) {
                textScale = Math.min(this.screenWidth / 1920, this.screenHeight / 1080);
            }
            else {
                textScale = Math.min(this.screenWidth / 1080, this.screenHeight / 1920);
            }

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;
            const tweenAlpha = new Tween(this.texContainer, this.tweenGroup)
                // .to({ alpha: 1 }, 200)
                .to({ scale: { x: textScale, y: textScale }, alpha: 1 }, 500)
                // .easing(Easing.Bounce.Out)
                .onStart(() => {
                    this.switchTheBackgroundMusic(toFreeGame);
                })
                .onComplete(() => {
                    this.eventMode = "static";
                    // this.bgContainer.cursor = 'pointer';
                    this.tweenGroup.remove(tweenAlpha);

                    resolve();
                })
                .start();

            const tweenBreath = new Tween(this.continueText.scale, this.tweenGroup)
                .to({ x: 1.03, y: 1.03 }, 1000) // Scale up
                .yoyo(true) // Automatically reverses the tween
                .repeat(Infinity) // Infinite loop
                .onComplete(() => {
                    this.tweenGroup.remove(tweenBreath);
                })
                .start();
            //  const tweenBreathBase = new Tween(this.continueBase.scale, this.tweenGroup)
            //     .to({ x: 1.03, y: 1.03 }, 1000) 
            //     .yoyo(true) 
            //     .repeat(Infinity)
            //     .onComplete(() => {
            //         this.tweenGroup.remove(tweenBreathBase);
            //     })
            //     .start();

        })

    }

    private switchTheBackgroundMusic(toFreeGame: boolean) {

        let targetMusicLoop;
        if (toFreeGame) {
            targetMusicLoop = sound.find('free_background_loop');
        }
        else {
            targetMusicLoop = sound.find('base_music_loop');
        }

        let currentVal: number = currentBackgorundMusicVolume;
        let targetVal: number = 0;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 750)
            .onUpdate((object) => {
                currentBackgorundMusic.volume = object.x;
                // console.log("this.backGroundMusic", this.backGroundMusic.volume);
            })
            .onComplete(() => {
                this.tweenGroup.remove(tween);
                playFgMusic();

            })
            .start();


        const playFgMusic = () => {
            let currentVal: number = .10;
            let targetVal: number = currentBackgorundMusicVolume;

            // initialize with ambient sound
            setBackgorundMusic(targetMusicLoop);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 750)
                .onStart(() => {
                    currentBackgorundMusic.loop = true;
                    currentBackgorundMusic.singleInstance = true;
                    currentBackgorundMusic.play();
                    currentBackgorundMusic.muted = !isMusicBtnOnGlobal;
                })
                .onUpdate((object) => {
                    currentBackgorundMusic.volume = object.x;

                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();
        }
    }



    public async disappearBanner(): Promise<void> {
        return new Promise<void>(async (resolve) => {


            // if (!isBase) {
            //     this.switchTheBackgroundMusic(false);
            // }

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 0 }, 200)
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })

            const promises: Promise<void>[] = [];

            const playOutAnimation = (baseAnimSpine: Spine) => {
                return new Promise<void>((resolve) => {
                    baseAnimSpine.state.setAnimation(0, "out", false).listener = {
                        complete: () => {
                            baseAnimSpine.state.clearListeners();
                            resolve();
                        }
                    };
                });
            };

            promises.push(playOutAnimation(this.baseAnim));

            // const playTransitionAnimation = (transitionAnim: Spine) => {
            //     return new Promise<void>((resolve) => {
            //         transitionAnim.visible = true;
            //         transitionAnim.state.setAnimation(0, "animation", false).listener = {
            //             complete: () => {
            //                 transitionAnim.state.clearListeners();
            //                 resolve();
            //             }
            //         };
            //     });
            // };
            // promises.push(playTransitionAnimation(this.transitionAnim));

            Promise.all(promises).then(() => {
                this.visible = false;
                this.eventMode = "none";
                // this.bgContainer.cursor = 'none';
                resolve();
            });

        });
    }

    public async appearFreeGameOutroBanner(totalWin: number, freeSpins: number) {

        return new Promise<void>((resolve) => {

            this.isIntroBanner = false;

            this.visible = true;

            this.bannerText3.visible = false;
            this.bannerText4.visible = false;
            // this.bannerText5.visible = false;

            this.winText.visible = true;

            this.bannerText1.scale = 1;
            this.bannerText1.text = translationManager.game('banner_outro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 900 / this.bannerText1.width);
            this.bannerText1.y = -360;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_outro_desc_1', null, { 'winnumber': freeSpins });
            this.bannerText2.y = -170;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);


            this.winText.scale = 1;
            this.winText.text = totalWin.toFixed(2);
            this.winText.scale = Math.min(1, 900 / this.winText.width);
            this.winText.y = 0;

            this.continueText.y = 240;

            this.resize(this.screenWidth, this.screenHeight); // to set the position according to screen size

            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            const tween = new Tween(this.backgroundImg, this.tweenGroup)
                .to({ alpha: 1 }, 200)
                .onStart(() => {
                    sound.play('total_win', { volume: 1 });
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();

            // sound.play('free_Game_Banner', { volume: 0.25 });
            const promises: Promise<void>[] = [];

            const playInAnimation = (characterSpine: Spine): Promise<void> => {
                return new Promise<void>((resolveCharacter) => {
                    characterSpine.state.setAnimation(0, "in", false).listener = {
                        complete: () => {
                            characterSpine.state.setAnimation(0, "loop", true);
                            characterSpine.state.clearListeners();
                            resolveCharacter();
                        }
                    };
                });
            };

            promises.push(playInAnimation(this.baseAnim));
            //promises.push(playInAnimation(this.rightCharacter));

            Promise.all(promises).then(async () => {
                await this.appearText(false);
                resolve();
            });

        })




    }

    public resize(screenWidth: number, screenHeight: number): void {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 1920, screenHeight / 1920);


        // this.rightCharacter.scale = 0.85;

        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);




            this.texContainer.scale.set(scale, scale);

            const xPos = (3000 * bgScale - screenWidth) / 2;
            const yPos = (3000 * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;

            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            this.baseAnim.scale = 1;
            this.baseAnim.position.set(960, 540);


            // this.rightCharacter.position.set(100, 750);
            if (this.isIntroBanner) {
                this.bannerText1.y = -325;
                this.bannerText2.y = -230;
                this.bannerText3.y = -130;
                this.bannerText4.y = 100;
                this.continueText.y = 340;
            }
            else if (!this.isIntroBanner) {
                this.bannerText1.y = -300;
                this.bannerText2.y = -200;
                // this.bannerText3.y = -57;
                this.winText.y = 0;
                this.continueText.y = 300;
            }

        }
        else {
            scale = Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);


            this.texContainer.scale.set(scale, scale);

            const xPos = (3000 * bgScale - screenWidth) / 2;
            const yPos = (3000 * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;


            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            this.baseAnim.scale = 1;
            this.baseAnim.position.set(960, 540);
            // this.rightCharacter.position.set(100, 733);
            if (this.isIntroBanner) {
                this.bannerText1.y = -325;
                this.bannerText2.y = -225;
                this.bannerText3.y = -130;
                this.bannerText4.y = 100;
                this.continueText.y = 340;
            }
            else if (!this.isIntroBanner) {
                this.bannerText1.y = -300;
                this.bannerText2.y = -200;
                // this.bannerText3.y = -57;
                this.winText.y = 0;
                this.continueText.y = 300;
            }

        }

        this.texContainer.position.set(screenWidth / 2, screenHeight / 2);

        // Sync continue base position with text
        this.continueBase.y = this.continueText.y + 5;
        this.continueBase.x = this.continueText.x; // (0,0 relative to container center)
        this.continueBase.scale = 0.8;

    }

    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }
}